export default __webpack_public_path__ + "static/media/warning--quay-or-river-bank--g2.f72ff26e.png";